module.exports = __webpack_public_path__ + "img/grafico.9383221a.png";